import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleGuard } from '../../guard/auth-guard/role.guard';
import { Role } from '../../core/enums/role.enum';

export const relatoriosRoutes: Routes = [
  {
    path: 'relatorios/desligamento-profissional',
    loadComponent: () =>
      import('../desligamento-profissional/relatorio-desligamento/relatorio-desligamento.component').then(
        (m) => m.RelatorioDesligamentoComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.DESLIGAMENTO_CN_RELATORIO, Role.DESLIGAMENTO_CN_CONSULTAR],
      title: 'Relatório de Desligamento',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Relatório de Desligamento' },
      ],
    },
  },
  {
    path: 'relatorios/desligamento-profissional/visualizar',
    loadComponent: () =>
      import('../desligamento-profissional/relatorio-desligamento/relatorio-desligamento-visualizar/relatorio-desligamento-visualizar.component').then(
        (m) => m.RelatorioDesligamentoVisualizarComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.DESLIGAMENTO_CN_RELATORIO, Role.DESLIGAMENTO_CN_CONSULTAR],
      title: 'Visualizar Relatório de Desligamento',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Relatório de Desligamento', url: '/relatorios/desligamento-profissional' },
        { label: 'Visualizar' },
      ],
    },
  },
  {
    path: 'relatorios',
    loadComponent: () =>
      import('./relatorios.component').then((m) => m.RelatoriosComponent),
    canActivate: [AuthGuard],
    data: {
      roles: [Role.RELATORIOS_VISUALIZAR],
      title: 'Relatórios',
      breadcrumb: [{ label: 'Relatórios', url: '/relatorios' }],
    },
  },
  {
    path: 'relatorios/homologacao',
    loadComponent: () =>
      import('./relatorio-homologacao/relatorio-homologacao.component').then(
        (m) => m.RelatorioHomologacaoComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_HOMOLOGACAO_VISUALIZAR],
      title: 'Relatório de Homologação',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Homologação de Vagas', url: '/relatorios/homologacao' },
      ],
    },
  },
  {
    path: 'relatorios/analise-documental',
    loadComponent: () =>
      import('./relatorio-analise-documental/relatorio-analise-documental.component').then(
        (m) => m.RelatorioAnaliseDocumentalComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_ANALISE_DOCUMENTAL_VISUALIZAR],
      title: 'Relatório de Análise Documental',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Análise Documental', url: '/relatorios/analise-documental' },
      ],
    },
  },
  {
    path: 'relatorios/confirmacao-vaga',
    loadComponent: () =>
      import('./relatorio-confirmacao-vaga/relatorio-confirmacao-vaga.component').then(
        (m) => m.RelatorioConfirmacaoVagaComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_CONFIRMACAO_VAGA_VISUALIZAR],
      title: 'Relatório de Confirmação de Vaga',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Confirmação de Vaga', url: '/relatorios/confirmacao-vaga' },
      ],
    },
  },
  {
    path: 'relatorios/rms',
    loadComponent: () =>
      import('../relatorio-rms/relatorio-rms.component').then((m) => m.RelatorioRmsComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_RMS_VISUALIZAR],
      title: 'Relatório RMS',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Relatório RMS', url: '/relatorios/rms' },
      ],
    },
  },
  {
    path: 'relatorios/gerencial',
    loadComponent: () =>
      import('./relatorio-gerencial/relatorio-gerencial-galeria.component').then(
        (m) => m.RelatorioGerencialGaleriaComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_GERENCIAL_VISUALIZAR],
      title: 'Central de Relatórios',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Central de Relatórios', url: '/relatorios/gerencial' },
      ],
    },
  },
  {
    path: 'relatorios/gerencial/construtor',
    loadComponent: () =>
      import('./relatorio-gerencial/relatorio-gerencial-construtor.component').then(
        (m) => m.RelatorioGerencialConstrutorComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_GERENCIAL_VISUALIZAR],
      title: 'Central de Relatórios',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Central de Relatórios', url: '/relatorios/gerencial' },
        { label: 'Nova consulta', url: '/relatorios/gerencial/construtor' },
      ],
    },
  },
  {
    path: 'relatorios/gerencial/administracao',
    loadComponent: () =>
      import('./relatorio-gerencial/relatorio-gerencial-admin.component').then(
        (m) => m.RelatorioGerencialAdminComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [Role.RELATORIO_GERENCIAL_ADMINISTRAR],
      title: 'Administração do catálogo de Relatórios',
      breadcrumb: [
        { label: 'Relatórios', url: '/relatorios' },
        { label: 'Central de Relatórios', url: '/relatorios/gerencial' },
        { label: 'Administração do catálogo', url: '/relatorios/gerencial/administracao' },
      ],
    },
  },
];
